import React from "react";
import { useSearchParams } from "react-router-dom";
import config from "../../api/api-helper";
import { useTranslation } from "react-i18next";

import "./postBookingPages.css";

function BookingCancelPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.entries().next().value;
  const [isCancelling, setIsCancelling] = React.useState(false);
  const [cancelSuccess, setCancelSuccess] = React.useState(false);
  const [cancelErrorKey, setCancelErrorKey] = React.useState(null);

  const cancelBookingHandler = () => {
    setIsCancelling(true);
    setCancelErrorKey(null);

    fetch(`${config.apiUrl}/api/sopotak/v1/bookings/${bookingId[0]}/cancel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        setIsCancelling(false);

        // handle empty response body for 404 or error
        let data = {};
        try {
          data = await response.json();
        } catch (e) {
          // Do nothing, response body is empty
        }

        if (response.ok) {
          setCancelSuccess(true);
        } else if (response.status === 403 && data.message === "BOOKING_CANCELLATION_PERIOD_EXCEEDED") {
          setCancelErrorKey("bookingCancel.errors.tooLate");
        } else if (response.status === 403 && data.message === "BOOKING_ALREADY_CANCELLED") {
          setCancelErrorKey("bookingCancel.errors.alreadyCancelled");
        } else if (response.status === 404) {
          setCancelErrorKey("bookingCancel.errors.notFound");
        } else {
          setCancelErrorKey("bookingCancel.errors.unexpected");
        }
      })
      .catch((error) => {
        setIsCancelling(false);
        setCancelErrorKey("bookingCancel.errors.unexpected");
      });
  };

  return (
    <div className="main-container">
      <div className="payment-error-container">
        <div className="payment-error-spacer" />
        <span className="payment-error-span">
          {t("bookingCancel.bookingNumber")}: <b>{bookingId}</b>
        </span>
        {cancelSuccess ? (
          <div className="cancel-success-message">
            {t("bookingCancel.success")}
          </div>
        ) : (
          <>
            <button
              className="cancel-booking-button"
              onClick={cancelBookingHandler}
              disabled={isCancelling}
            >
              {isCancelling ? t("bookingCancel.cancelling") : t("bookingCancel.button")}
            </button>
            {cancelErrorKey && (
              <div className="cancel-error-message">
                {t("bookingCancel.error")} {t(cancelErrorKey)}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default BookingCancelPage;
